<div class="avatar-container">
  <img
    *ngIf="imgSrc; else defaultProfilePicture"
    [src]="imgSrc"
    [alt]="altText"
    class="avatar-image"
  />
  <ng-template #defaultProfilePicture>
    <i class="fas fa-user"></i>
  </ng-template>
</div>
